/**
 * Visible label for demonstration content and assets (decisions D-02, D-05).
 * `decorative` hides it from screen readers where the accessible name already
 * says MOCK (for example a mock image's alt text), to avoid hearing it twice.
 */
export function MockBadge({
  decorative = false,
}: {
  decorative?: boolean
}): React.JSX.Element {
  return (
    <span
      className="rounded-md bg-fuchsia-100 px-2 py-0.5 text-base font-bold tracking-wide text-fuchsia-900 dark:bg-fuchsia-950 dark:text-fuchsia-200"
      {...(decorative ? { 'aria-hidden': true } : {})}
    >
      MOCK
    </span>
  )
}
